import { useChatConnection } from 'connections/chat';
import { IConnections } from 'connections/types';
import { createContext, useContext } from 'react';
import { IChildrenProp } from 'types/components/components.interface';

const ConnectionContext = createContext<IConnections | undefined>(undefined);

export const ConnectionProvider = ({ children }: IChildrenProp) => {
  const chat = useChatConnection();

  return (
    <ConnectionContext.Provider value={{ chat }}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useOfficeConnection = () => {
  const context = useContext(ConnectionContext);
  if (!context) {
    throw new Error('useConnection must be used within an ConnectionProvider');
  }
  return context;
};
